import { AuthService } from './../../../core/services/auth-service/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  emailSended,
  invalidMail,
  noAccountMail,
  serverError,
} from './../../../core/models/messages';
import { patternEmail } from './../../../core/models/pattern';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';

@Component({
  selector: 'app-reset-mail',
  templateUrl: './reset-mail.component.html',
  styleUrls: ['./reset-mail.component.css'],
})
export class ResetMailComponent implements OnInit {
  /* generate email control */
  emailControl = new FormControl();
  /* boolean */
  loadSpinner: boolean = false;
  entrepriseInfo: any;
  userEmail!: string;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private toastrService: ToastrService,
    private authService: AuthService,
    private router: Router,
    private reCaptchaService: ReCaptchaService,
  ) {}
  /* init */
  ngOnInit(): void {
    this.emailControl.addValidators([
      Validators.required,
      Validators.email,
      Validators.pattern(patternEmail),
    ]);
  }

  sendMailValidation() {
    if (this.emailControl.valid) {

      this.reCaptchaService.executeAction('resetMail').then(token => {
        let data = {
          email: this.emailControl.value,
          recaptchaToken: token
        };
        this.loadSpinner = true;
        this.authService
        .resetMail(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: { status: number; data: any }) => {
            if (res.status == 200) {
              this.loadSpinner = false;
              this.toastrService.success(emailSended);
              this.router.navigate([
                'auth/code-reset',
                { email: this.emailControl.value },
              ]);
            }
          },
          error: (err: any) => {
            this.loadSpinner = false;
            if (err.error.status == 409) {
              this.toastrService.error(noAccountMail);
            } else if (err.error.status == 404)
              this.toastrService.error(invalidMail);
            else this.toastrService.error(serverError);
          },
        });
    }).catch(err => {
      this.loadSpinner = false;
      this.toastrService.error('reCAPTCHA verification failed. Please try again.'); // Optional
    });
  }
 }
}
